"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTING_TYPE = void 0;
exports.SETTING_TYPE = {
    SELECT_ARRAY: 'SELECT_ARRAY',
    BOOLEAN: 'BOOLEAN',
    INTEGER: 'INTEGER',
    FLOAT: 'FLOAT',
    STRING: 'STRING',
    SELECT: 'SELECT',
    JSON: 'JSON',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    PRODUCT: 'PRODUCT',
    PRODUCTS_LIST: 'PRODUCTS_LIST',
    PRODUCTS_COLLECTION: 'PRODUCTS_COLLECTION',
    PRODUCTS_SIMPLE_COLLECTION: 'PRODUCTS_SIMPLE_COLLECTION',
    QUIZ: 'QUIZ',
    TRIVIA_QUIZ: 'TRIVIA_QUIZ',
    TESTIMONIALS: 'TESTIMONIALS',
    LANDING_PRODUCT: 'LANDING_PRODUCT' // TODO - deprecated value, convert and remove
};
//# sourceMappingURL=settingType.js.map